import { TextAreaWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-textarea-widget',
  templateUrl: './textarea.widget.html'
})
export class MyTextAreaWidgetComponent extends TextAreaWidget { }



// WEBPACK FOOTER //
// ./src/shared/form-widgets/textarea/textarea.widget.ts